import { render, staticRenderFns } from "./ReleaseProductForm.vue?vue&type=template&id=1022e52e&"
import script from "./ReleaseProductForm.vue?vue&type=script&lang=js&"
export * from "./ReleaseProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports